import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IRegistration } from '../model/IRegistration';
import { UserSettings } from '../model/UserSettings';
import * as PageStore from "src/app/Store/PageStore/Page.Actions";
import { APICallingService } from '../model/APICallingService';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.css']
})
export class UserRegistrationComponent implements OnInit {

  constructor(private apiCall:APICallingService,private router:Router,private store: Store<any>) { }
   registration:IRegistration={

    firstName:'',
    lastName:'',
    country:'',
    state:'',
    city:'',
    address:'',
    pinCode:'',
    email:'',
    phoneNo:'',
    password:''
  }
  // lstDeliveryLocation=[{LocationID:'0',LocationName:''}];
  lstDeliveryLocation=[{ZipCode:'',LocationName:''}];
  storeUserSettings:any;
  ngOnInit(): void {
    debugger;
    let storeDeliveryLocation = (this.store as any).source['value']['MSFOO'].filter((x:any) => {
      return x.viewName == 'AppSettings';
      
    });
    if( storeDeliveryLocation.length > 0) {
  
      let storeBranch=Object.assign({},  storeDeliveryLocation[0]);
  debugger;
    this.lstDeliveryLocation=Object.assign([], storeBranch.selectedBranch.lstDeliveryLocation) ;
      
    }

    this.storeUserSettings=new  UserSettings();
    var result = (this.store as any).source['value']['MSFOO'].filter((x:any) => { return x.viewName == "UserDetails"; });
    if (result.length > 0) {
    
     this.storeUserSettings=( Object.assign({},result[0] ));
this.registration.firstName=this.storeUserSettings.FirstName;
this.registration.lastName=this.storeUserSettings.LastName;
this.registration.country=this.storeUserSettings.Country;
this.registration.city=this.storeUserSettings.City;

this.registration.state=this.storeUserSettings.State;
this.registration.address=this.storeUserSettings.Address;
this.registration.pinCode=this.storeUserSettings.PinCode;
this.registration.phoneNo=this.storeUserSettings.Mobile;
this.registration.email=this.storeUserSettings.Email;

    }
  
  }

  validateMobile(input:any):boolean
  {
  
  
  
  var regexp=new RegExp(/^[6-9]\d{9}$/);
    var res= regexp.test(input)
  
   return res;
  }
  validateEmail(input:any):boolean
  {
  
  
  
  var regexp=new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    var res= regexp.test(input)
  
   return res;
  }
 
  validateTextOnlyLetters(e:any)
  {
    debugger;
 $(e.target).val(($(e.target).val() as any).replace(/[^a-zA-Z ]+?/, ''));

  }


  validateUserRegistration():boolean
  {
    debugger;
var validate=true;


if(this.registration.firstName=='')
{
validate =false;

}

//var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);




if(this.registration.lastName=='' && validate)
{
validate =false;

}


if(this.registration.address=='' && validate)
{
validate =false;

}


if(this.registration.pinCode=='' && validate)
{
validate =false;

}
var valEmail=this.validateEmail(this.registration.email);
if((this.registration.email==''|| (valEmail!=true))&& validate)
{


validate =false;

}


if(this.registration.phoneNo=='' && validate)
{
validate =false;

}

var valPhone=this.validateMobile(this.registration.phoneNo);
if((this.registration.phoneNo==''|| (valPhone!=true))&& validate)
{


validate =false;

}





if(this.storeUserSettings.UserID==0)
{
if(this.registration.password=='' && validate)
{
validate =false;

}


if(this.rePassword=='' && validate)
{
validate =false;

}
if(this.rePassword!=this.registration.password && validate)
{
validate =false;

}
}
return  validate;

  }

  // setLocation(val:any)
  // {
  //   this.registration.pinCode=val.target.value;

  // }
  
  setLocation(val:any)
  {
    debugger;
    this.registration.pinCode=val.target.value
    this.registration.city=((this.lstDeliveryLocation as any).filter((x: any) => (x as any).ZipCode==val.target.value))[0].LocationName;
  }
  rePassword='';
  submited=false;
  saveClick()
  {
this.submited=true;
if(this.validateUserRegistration())
{
  this.SaveTransaction();
}
  }
  dbResult:any;
  SaveTransaction()
  {
 debugger;
   var xml1='<NewDataSet><Table1>'
      
   +'<UserID>'+this.storeUserSettings.UserID+'</UserID>'
   +'<Password>'+this.registration.password+'</Password>'
   +'<FirstName>'+this.registration.firstName+'</FirstName>'
   +'<LastName>'+this.registration.lastName+'</LastName>'
   +'<City>'+this.registration.city+'</City>'
   +'<State>'+this.registration.state+'</State>'
   +'<Zip>'+this.registration.pinCode+'</Zip>'
   +'<Country>'+this.registration.country+'</Country>'
   +'<Address>'+this.registration.address+'</Address>'
   +'<Mobile>'+this.registration.phoneNo+'</Mobile>'
   +'<Email>'+this.registration.email+'</Email>'
   +'</Table1></NewDataSet>';
 debugger;
 this.apiCall.DBCalling("SaveUsers",xml1,"","","").subscribe(
     (res:any) => 
     {
      debugger;

      // this.dbResult= (res);
      this.dbResult= (res);
     
      if(this.dbResult.tasks.length>0 )
      {
        let i=0;
        if(this.dbResult.tasks[i][0].dbResult=='-3' )
        {
          
         
          // alert("User Already Exists.Please Login and Continue !");
          Swal.fire({
            position: 'center',
            icon: 'warning',
            text:'User Already Exists.Please Login and Continue !'
          });
         
          
        
       
        }else{
 
         this.storeUserSettings=new UserSettings();
 this.storeUserSettings.UserID=this.dbResult.tasks[i][0].UserID;
 this.storeUserSettings.Email=this.registration.email;
 this.storeUserSettings.FirstName=this.registration.firstName;
 this.storeUserSettings.LastName=this.registration.lastName;
 this.storeUserSettings.City=this.registration.city;
 this.storeUserSettings.State=this.registration.state;
 this.storeUserSettings.PinCode=this.registration.pinCode;
 this.storeUserSettings.Country=this.registration.country;
 this.storeUserSettings.Address=this.registration.address;
 this.storeUserSettings.Mobile=this.registration.phoneNo;
 this.store.dispatch(new  PageStore.OpenPage(this.storeUserSettings));
        
 this.router.navigate(['/online-order/home'])
 .then(() => {
   window.location.reload();
 });
  
 
        }
      }else
      {
     
        // alert("failed.! Contact System Admin");
        Swal.fire({
          position: 'center',
          icon: 'error',
          text:'failed.! Contact System Admin'
        }); 
      }
      } );
     
 
  }

  loginClick(){
    this.router.navigateByUrl('/login');
  }

  homeClick(){
    this.router.navigateByUrl('/');
  }
}
